export const APP_NAME = 'RiskIntegrity™ Investment Insight';
export const LOGIN = `Log in - ${APP_NAME}`;
export const STRATEGIES = `Strategies - ${APP_NAME}`;
export const ANALYSIS = `Analysis - ${APP_NAME}`;
